import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert } from "reactstrap";
import { Button } from "zina-dogi-react";
import { Row, Col } from "reactstrap";
import service from "../../oet/redux/service";
import { utils } from "~/utils";
import swal from "sweetalert";
import Dropzone from "react-dropzone";
import { ClipLoader } from "react-spinners";

class CommentsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            comments: [],
            requestData: {},
            withOnSend: false,
            nextStep: null,
            comment_file: null,
            isLoading: false
        };
    }

    close = () => {
        this.setState({
            modal: false,
            comments: [],
            requestData: {},
            withOnSend: false,
            nextStep: null,
            comment_file: null
        });
    };

    toggle = ({ requestData = {}, withOnSend = false, nextStep = null }) => {
        const modal = !this.state.modal;
        if (modal) {
            this.updateComments(requestData, true, withOnSend, nextStep);
        } else {
            this.close();
        }
    };

    updateComments = (requestData, open = false, withOnSend = false, nextStep = null) => {
        const { content_type, object_id } = requestData;
        if (content_type && object_id) {
            service
                .getComments(content_type, object_id)
                .then(response => {
                    const others = open && {
                        modal: true,
                        requestData,
                        withOnSend,
                        nextStep
                    };
                    const comments = response.results;
                    this.setState({
                        comments,
                        ...others
                    });
                })
                .catch(_ =>
                    swal({
                        title: "Warning ...",
                        text: "Something has gone wrong.",
                        icon: "warning",
                        timer: 3000,
                        button: true
                    })
                );
        }
    };

    saveComment = (comment, uploaded_file) => {
        if (comment) {
            const data = { ...this.state.requestData };
            Object.keys(data).forEach(key => data[key] === undefined && delete data[key]);
            if (Object.keys(data).length > 0) {
                this.setState({ isLoading: true });
                return service
                    .createComment({
                        ...data,
                        comment,
                        uploaded_file
                    })
                    .then(_ => {
                        this.updateComments(this.state.requestData);
                        this.setState({ isLoading: false });
                        this.text = "";
                        if (!this.state.withOnSend) {
                            this.close();
                        }
                    })
                    .catch(error => {
                        this.setState({ isLoading: false });
                        swal({
                            title: "Warning ...",
                            text: "Something has gone wrong",
                            icon: "warning",
                            timer: 3000,
                            button: true
                        });
                    });
            }
        }
    };

    send = () => {
        const { onSend } = this.props;
        const { nextStep } = this.state;
        if (nextStep) {
            if (this.text !== "") {
                this.saveComment(this.text, this.state.comment_file).then(_ => {
                    onSend(nextStep);
                    this.close();
                });
            } else {
                onSend(nextStep);
                this.close();
            }
        }
    };

    get text() {
        return this.refs.text_area.value;
    }

    onDrop = files => {
        const newFile = files[0];
        this.setState({ comment_file: newFile, errorMessage: [] });
    };
    onCancel = () => {
        this.setState({ comment_file: null, errorMessage: [] });
    };

    set text(newText) {
        this.refs.text_area.value = newText;
    }

    render() {
        const { className, buttonLabel } = this.props;
        const { modal, comments, nextStep } = this.state;
        const modalStyle = { width: "80%", maxWidth: "80%" };
        const zoneStyle = {
            width: "100%",
            height: 150,
            border: "2px dashed #888",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        };
        return (
            <div>
                {buttonLabel && (
                    <Button color="primary" onClick={this.toggle}>
                        {buttonLabel}
                    </Button>
                )}
                <Modal isOpen={modal} toggle={this.toggle} className={className} backdrop="static" style={modalStyle}>
                    <ModalHeader toggle={this.toggle}>Comments</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={7}>
                                <ul className="comment-section" style={{ margin: 0, height: "100%" }}>
                                    <li className="write-new">
                                        <textarea
                                            disabled={this.state.isLoading}
                                            required={true}
                                            className="form-control"
                                            placeholder="Write your comment here"
                                            name="comment"
                                            ref="text_area"
                                            style={{ height: 150 }}
                                        />
                                    </li>
                                    <li>
                                        <Dropzone
                                            disabled={this.state.isLoading}
                                            disableClick
                                            multiple={false}
                                            style={zoneStyle}
                                            onDrop={this.onDrop}
                                            onFileDialogCancel={this.onCancel}
                                        >
                                            {({ isDragActive, isDragReject, open }) => {
                                                if (isDragActive) {
                                                    return <p>File accepted</p>;
                                                }
                                                if (isDragReject) {
                                                    return <p>Files rejected</p>;
                                                }
                                                return (
                                                    <React.Fragment>
                                                        <p>Dropping file here ... or</p>
                                                        <button
                                                            disabled={this.state.isLoading}
                                                            className="btn btn-primary"
                                                            type="button"
                                                            onClick={() => open()}
                                                        >
                                                            Browse File
                                                        </button>
                                                    </React.Fragment>
                                                );
                                            }}
                                        </Dropzone>
                                        {this.state.comment_file && (
                                            <React.Fragment>
                                                <br />
                                                <Alert>{this.state.comment_file.name}</Alert>
                                                <br />
                                            </React.Fragment>
                                        )}
                                    </li>
                                </ul>
                            </Col>
                            <Col lg={5}>
                                <h5>Previous comments</h5>
                                <p style={{ color: "var(--secondary)" }}>comments previously added by users</p>
                                <ul
                                    className="comment-section"
                                    style={{
                                        margin: 0,
                                        padding: 0,
                                        maxHeight: "500px",
                                        overflow: "auto"
                                    }}
                                >
                                    <li />
                                    {comments &&
                                        comments.map((comment, i) => {
                                            return <Comment {...comment} key={`comment_${i}`} />;
                                        })}
                                </ul>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoading && (
                            <div className="float-right">
                                <ClipLoader />
                            </div>
                        )}
                        <Button disabled={this.state.isLoading} color="danger" onClick={this._cancel}>
                            Cancel
                        </Button>
                        <Button
                            disabled={this.state.isLoading}
                            icon="save"
                            color="primary"
                            onClick={() => this.saveComment(this.text, this.state.comment_file)}
                        >
                            Save Comment
                        </Button>
                        {this.props.onSend && this.state.withOnSend && this.state.nextStep && (
                            <Button
                                disabled={this.state.isLoading}
                                icon="paper-plane"
                                color="success"
                                onClick={_ => this.send()}
                            >
                                {nextStep.display}
                            </Button>
                        )}
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
    _cancel = () => {
        this.close();
    };
}

export default CommentsModal;

export const Comment = ({ comment, created_at, user, status, ...others }) => {
    others.className = `comment user-comment`;
    if (!user.email) {
        user = {
            id: user,
            email: "user email"
        };
    }
    const date = utils.renderDate(created_at);
    const ownUser = JSON.parse(localStorage.getItem("user"));
    const isAlt = ownUser.id === user.id ? "alt" : null;
    const name = isAlt ? (ownUser.email !== "" ? ownUser.email : ownUser.username) : user.email;
    return (
        <li {...others}>
            <div className="msg">
                <div className={["bubble", isAlt].join(" ")}>
                    <div className="txt">
                        <span className="name">{name}</span>
                        <p className="message">{comment}</p>
                        {others.uploaded_file && (
                            <a className="name" href={others.media_url}>
                                {others.original_filename}
                            </a>
                        )}
                        <span>
                            <hr />
                        </span>
                        <span className="timestamp">
                            {date}
                            {status && (
                                <span>
                                    {" - "}sent to {status}
                                </span>
                            )}
                        </span>
                    </div>
                    <div className={["bubble-arrow", isAlt].join(" ")} />
                </div>
            </div>
        </li>
    );
};
